/* eslint-disable arrow-body-style, max-len */

import { get } from 'lodash';
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import routes from '@/router/routes';
import ls from '@/helpers/localStorage';
import { isStandalone } from '@/mixins/userAgent';
import sessionVars from '@/helpers/sessionVars';
import { MODALS } from '@/components/app/app-modals/app-modals';

const DISABLE_RESTRICTED_ACCESS_ROUTES = [
  'disqus-auth',
  'social-auth',
  'home',
];

const DISABLE_CHECK_CLASSICS_ACCESS_ROUTES = [
  'terms-and-conditions',
];


Vue.use(Router);

const RouterInstance = new Router({
  base: process.env.ROOT_PATH,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to && get(to, 'params.dontReload', false)) {
      return null;
    }
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes,
});

RouterInstance.beforeEach((to, from, next) => {
  if (from && from.name && from.fullPath) {
    store.dispatch('app/setPreviousRoute', from.fullPath);
  }
  if (isStandalone && from.name && to.name && to.fullPath) {
    const expiresAt = 31536000;
    ls.set('currentRoutePath', to.fullPath, expiresAt);
  }

  const shouldCheckAccess = () => {
    return (
        process.env.RESTRICTED_ACCESS_ENABLED &&
        !DISABLE_RESTRICTED_ACCESS_ROUTES.includes(to.name)
      ) ||
      to.matched.some(record => record.meta.requiresAuth);
  };

  const shouldCheckAnonymous = () => {
    return to.matched.some(record => record.meta.requiresAnonymous);
  };

  const shouldCheckClassicsEnabled = () => {
    return !DISABLE_CHECK_CLASSICS_ACCESS_ROUTES.includes(to.name);
  };

  const serverApiVersion = parseInt(store.state.app.serverVersion || 0, 10);
  const initialApiVersion = parseInt(store.state.app.initialVersion || 0, 10);

  if (serverApiVersion && initialApiVersion && serverApiVersion > initialApiVersion) {
    window.location.reload();
  }

  const hasClassicsNotEnabled = store.state.user.status.isClassicEnabled === false;

  if (shouldCheckAccess()) {
    if (store.getters['user/isLoggedIn'] === false) {
      next({
        name: 'home',
        query: { redirect: to.fullPath },
      });
      store.dispatch('popup/setCurrentPopup', MODALS.LOGIN);
    } else if (hasClassicsNotEnabled) {
      store.dispatch('popup/setCurrentPopup', MODALS.ACCOUNT_ENABLE_CLASSIC)
        .then(() => next());
    } else {
      store.dispatch('popup/setCurrentPopup')
        .then(() => store.dispatch('popup/setCurrentSmallPopup'))
        .then(() => next());
    }
  } else if (shouldCheckAnonymous()) {
    if (store.getters['user/isLoggedIn'] === true) {
      next({ name: 'home', query: { ...to.query } });
    } else {
      next();
    }
  } else if (shouldCheckClassicsEnabled()) {
    if (hasClassicsNotEnabled) {
      store.dispatch('popup/setCurrentPopup', MODALS.ACCOUNT_ENABLE_CLASSIC)
        .then(() => next());
    } else {
      next();
    }
  } else {
    store.dispatch('popup/setCurrentPopup')
      .then(() => store.dispatch('popup/setCurrentSmallPopup'))
      .then(() => next());
  }
});

RouterInstance.afterEach((to) => {
  sessionVars.check(to);
  window.dataLayer = window.dataLayer || [];
  if (to && to.fullPath) {
    window.dataLayer.push({
      event: 'pageviewTrackerEvent',
      virtualPage: to.fullPath,
      virtualPageTitle: to.name,
    });
  }
});

export default RouterInstance;



// WEBPACK FOOTER //
// ./src/router/index.js